const migrateSelectionColumnVisibility = (model = {}) => {
  if (!model || typeof model !== 'object') return {};
  const next = { ...model };
  const mapping = {
    brands: 'brandsDisplay',
    vendorProvidedDateDisplay: 'vendorProvidedDate',
    productSelectionDateDisplay: 'productSelectionDate',
    goLiveDateDisplay: 'goLiveDate',
    cancelDateDisplay: 'cancelDate',
    billingStartDateDisplay: 'billingStartDate',
    billingEndDateDisplay: 'billingEndDate',
    effectiveDateDisplay: 'effectiveDate',
  };
  Object.entries(mapping).forEach(([oldKey, newKey]) => {
    if (Object.prototype.hasOwnProperty.call(next, oldKey) && !Object.prototype.hasOwnProperty.call(next, newKey)) {
      next[newKey] = next[oldKey];
      delete next[oldKey];
    }
  });
  return next;
};

const resolveLegacyValue = (col, row) => {
  if (!col || !row) return '';
  const raw = row[col.field];
  if (typeof col.valueGetter === 'function') {
    try {
      // most call-sites accept (value,row) or (params)
      return col.valueGetter(raw, row);
    } catch (_err) {
      try {
        return col.valueGetter({ row, value: raw, field: col.field, id: row.id });
      } catch (_err2) {
        return raw;
      }
    }
  }
  return raw;
};

const resolveLegacyRendered = (col, row) => {
  const value = resolveLegacyValue(col, row);
  if (typeof col.valueFormatter === 'function') {
    try {
      return col.valueFormatter({ row, value, field: col.field, id: row.id });
    } catch (_err) {
      // noop
    }
  }
  return value;
};

export { migrateSelectionColumnVisibility, resolveLegacyRendered, resolveLegacyValue };
